/**
 * Creado por Norte70
 *
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 29/09/2021
 */

const confirmPhoneRequest = () => {
    return {
        telefono: null,
        sid: null,
        code:null,
        client_id: process.env.VUE_APP_OAUTH20_CLIENT_ID,
    }
}

export default confirmPhoneRequest;